import { useInView } from '../../../hooks/useInView';

const problems = [
  {
    icon: 'ri-send-plane-line',
    title: 'スカウト送信が\n追いつかない',
    desc: '媒体を契約しているのに、業務が忙しくて送信件数が増やせない。せっかくの機能が活かせていない。',
  },
  {
    icon: 'ri-search-line',
    title: '媒体を\n使いこなせていない',
    desc: 'ターゲット設定や検索条件が複雑で、本当に会いたい学生に届いているか分からない。',
  },
  {
    icon: 'ri-bar-chart-line',
    title: '返信率が\n伸び悩む',
    desc: '送っても反応がない。スカウト文面をどう改善すればいいか、ノウハウも時間もない。',
  },
  {
    icon: 'ri-user-settings-line',
    title: '採用業務が\n属人化している',
    desc: '担当者が変わるたびにノウハウがリセット。安定した採用活動の仕組みが作れていない。',
  },
];

export default function ProblemSection() {
  const { ref, inView } = useInView();

  return (
    <section id="problem" className="py-10 md:py-20 bg-[#f7f5f2]">
      <div ref={ref} className="max-w-6xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className={`text-center mb-8 md:mb-14 transition-all duration-700 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="text-xs tracking-widest text-[#E8601C] font-medium uppercase mb-3 block">
            PROBLEM
          </span>
          <h2
            className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#1a2e4a] leading-tight"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            こんな課題、<br />抱えていませんか？
          </h2>
          <p className="text-[#666] text-sm mt-4 leading-relaxed">
            多くのベンチャー・中小企業の採用担当者が、<br className="hidden md:block" />
            同じ壁にぶつかっています。
          </p>
        </div>

        {/* Problem Cards */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">
          {problems.map((p, i) => (
            <div
              key={i}
              className={`bg-white rounded-2xl p-6 sm:p-7 flex flex-col items-start gap-4 border border-gray-100 hover:border-[#1a2e4a]/20 transition-all duration-700 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: inView ? `${i * 120 + 250}ms` : '0ms' }}
            >
              <div className="w-11 h-11 flex items-center justify-center bg-[#f0f4f9] rounded-xl">
                <i className={`${p.icon} text-[#1a2e4a] text-xl`} />
              </div>
              <h3
                className="text-base font-bold text-[#1a2e4a] leading-snug whitespace-pre-line"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                {p.title}
              </h3>
              <p className="text-sm text-[#666] leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>

        {/* Transition */}
        <div className={`mt-10 sm:mt-14 text-center transition-all duration-700 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{ transitionDelay: inView ? '700ms' : '0ms' }}>
          <div className="inline-flex items-center gap-3 bg-[#1a2e4a] text-white rounded-2xl px-6 sm:px-8 py-4">
            <i className="ri-lightbulb-line text-[#E8601C] text-lg flex-shrink-0" />
            <p className="text-sm font-medium leading-relaxed text-left">
              これらの課題を、スカウト代行の専門チームが<strong>まるごと解決</strong>します。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
